/***************************
 * Local Storage Utilities
 ***************************/

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import numberToWords from "number-to-words"

dayjs.extend(customParseFormat)

const phicRegCompanyName = "CLINICA PRIME CEBU, INC.";

// Return user data from local storage
export const getLocalData = (name) => {
    const data = localStorage.getItem(name);
    if (data) return JSON.parse(data);
    else return null;
};

export const getUser = () => {
    const data = localStorage.getItem('user_id')
    if (data) return JSON.parse(data);
    else return null;
}

export const getFullName = () => {
    const data = localStorage.getItem('full_name')
    if (data) return JSON.parse(data);
    else return null;
}

export const getUserRole = () => {
    const data = localStorage.getItem('role_name')
    if (data) return JSON.parse(data);
    else return null;
}

export const getToken = () => {
    const data = localStorage.getItem('token')
    if (data) return JSON.parse(data);
    else return null;
}

export const getEmployeeId = () => {
    const data = localStorage.getItem('employee_id');
    if (data && data!=="undefined") return JSON.parse(data);
    else return null
}

export const getIsAdminLogin = () => {
    const data = getUserRole();
    if (data) return data === "Administrator"
    else return false;
}

// Example: dateStr = "2023-05-16T07:00:00.766Z" -> "07:00"
export const extractDateTime = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const formattedTime = `${year}-${month}-${day}_${hours}:${minutes}`;
    return(formattedTime)
};

// Example: dateStr = "2023-05-16T07:00:00.766Z" -> "07:00"
export const extractTime = (dateStr) => {
    const date = new Date(dateStr);
    const hours = date.getHours().toString().padStart(2, "0");
    const minutes = date.getMinutes().toString().padStart(2, "0");
    const formattedTime = `${hours}:${minutes}`;
    return(formattedTime)
};

// Example: dateStr = "2023-05-16T07:00:00.766Z" -> "2023-05-16"
export const extractDate = (dateStr) => {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return(`${year}-${month}-${day}`)
};

// Example: "2023-05-16" -> "May 16, 2023"
export const formatDate = (dateString) => {
    const moment = require('moment');
    return moment(dateString).format("MMMM D, YYYY");
}

export const capitalizeText = (text) => {
    return text?.charAt(0)?.toUpperCase() + text?.slice(1);
  }

export const formatDateTime = (dateTimeString) => {
    const moment = require('moment');
    return moment(dateTimeString).format("MMMM D, YYYY HH:mm:ss A");
};

export const getTodayDateISO = () => {
    let date = new Date();
    return date.toISOString().split("T")[0];
  };

export const formatYMD = (dateString) => {
    const moment = require('moment');
    return moment(dateString).format('YYYY-MM-DD');
}

export const formatShortDate = (dateString) => {
    const moment = require('moment');
    return moment(dateString).format("MMM D, YYYY");
}

// Example: "16:19:00" -> "04:19 PM"
export const formatTime = (timeString) => {
    const moment = require('moment');
    return moment(timeString, "HH:mm:ss").format("hh:mm A");
}

export const formatNumber = (number) => {
    const formattedNumber = (Math.ceil(number * 100) / 100).toFixed(2);
    const parts = formattedNumber.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
}

export const formatAmount = (number) => {
    if (number) {
        return Number(number).toLocaleString("en-US", {minimumFractionDigits: 2, maximumFractionDigits: 2})
    } else return 0.00;
}

export const extractAmount = (input) => {
    if (input) {
        if (typeof input !== "string") {
            input = toString(input);
        }
        const outputStr = input.replace(/,/g, '');
        return parseFloat(outputStr).toFixed(2);
    } else 
    
    return null;
}

export const formartNumberToWords = (num) => {
    if (num) {
      const number = parseFloat(num).toFixed(2);
      const pesos = number.split('.')[0];
      const cents = number.split('.')[1];
      const pesoWord = capitalizeEachWord(numberToWords.toWords(pesos));
      const centWord = capitalizeEachWord(numberToWords.toWords(cents));
      if (Number(cents) > 0) {
        const result = `${pesoWord} pesos and ${centWord} cents`;
        return result;
      } else {
        return `${capitalizeEachWord(pesoWord)} pesos`;
      }
    } else return null
  }

export const getSum = (intputArray) => {
    if (intputArray) {
        let total = 0;
        intputArray.forEach((number) => {
            // var convertedNum = extractAmount(number);
            var num = number?parseFloat(number):0;
            total += num;
        }) 
        return parseFloat(total).toFixed(2);
    } else {
        return 0.00;
    }
}

export const minsToHours = (mins) => {
    if (mins) return (Number(mins)/60).toFixed(2);
    else return 0;
}

export const isValidNumber = (input) => {
    if (input) {
        // const strippedInput = input.replace(/,/g, '');
        const strippedInput = extractAmount(input);
        return !isNaN(parseFloat(strippedInput));  
    } else return false
}

// Example: time = "3:12:00"
export const convertToDateObj = (time) => {
    return dayjs(time, 'HH:mm');
}

// Ex. "2015-01-01"
export const convertToDate = (date) => {
    return dayjs(date, 'YYYY-MM-DD')
}

// Ex. "hello, world!" -> "Hello, World!"
export const capitalizeEachWord = (str) => {
    if (str) {
        var words = str.split(" ");
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
        }
        return words.join(" ");
    } else return null
}

export const removeUnderscore = (str) => {
    return str.replace(/_/g, ' ');
}

export const removeUnderscoreToSentence = (str) => {
    if (str && str.includes('_')) {
        return str.split('_').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    } else {
        return str.toLowerCase().replace(/(^|\s)[a-z]/g, (char) => char.toUpperCase());
    }
}

export const refreshPage = () => {
  window.location.reload();
};

export const fallback = "data:image/png;base64,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"


export async function convertImageFromUrlToFileVM5(pictureArray) {
    try {
        return Promise.all(
            pictureArray.map(async (photo) => {
            try {
                const proxyUrl = `${
                process.env.REACT_APP_LINK
                }files/get_file?file=${encodeURIComponent(photo?.file_url)}`
                const response = await fetch(proxyUrl)
                if (!response.ok)
                throw new Error(`HTTP error! status: ${response.status}`)
    
                const blob = await response.blob()
                const fileName = photo.file_name
                const fileType = fileName.split(".").pop().toLowerCase()
                let details = {}
    
                if (["jpg", "jpeg", "png", "gif", "webp"].includes(fileType)) {
                details = {
                    type: blob.type !== "text/html" ? blob.type : `image/${fileType}`,
                }
                } else if (fileType === "pdf") {
                details = {
                    type:
                    blob.type !== "text/html"
                        ? blob.type
                        : `application/${fileType}`,
                }
                } else {
                details = {
                    type: blob.type,
                }
                }
    
                const file = new File([blob], fileName, details)
    
                return {
                id: photo.id || "",
                uid: `${fileName}-${photo.id}`,
                file_name: fileName,
                status: "done",
                file_url: photo.file_url,
                originFileObj: file,
                }
            } catch (err) {
                console.warn(`Failed to fetch image for: ${photo?.file_url}`, err)
                return null // or you could return a fallback object if needed
            }
        }),
        ).then((results) => results.filter(Boolean)) // filter out failed/null entries
    } catch (error) {
      console.error("Error in convertImageFromUrlToFile:", error)
      return []
    }
}